import { ArrowRight, Map as MapIcon } from 'lucide-react';
import { Link } from 'react-router';
import { SITE_NAME } from '../../../shared/seo/pages.ts';
import { useNow } from '../../hooks/useNow.ts';
import { formatTime } from '../../lib/format.ts';
import { HERO_IMAGE } from './hero-image.ts';

const dayFormat = new Intl.DateTimeFormat('fr-FR', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  timeZone: 'Europe/Paris',
});

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/**
 * Hero éditorial pleine largeur : identité locale, promesse, deux accès directs.
 * L'image est l'élément LCP : chargée immédiatement, avec priorité haute, dimensions connues.
 */
export function Hero() {
  const now = useNow(30_000);
  const image = HERO_IMAGE;
  return (
    <section className="hero" aria-labelledby="hero-title">
      <picture className="hero__media">
        {image.sources?.map((source) => (
          <source key={source.type} type={source.type} srcSet={source.srcSet} sizes="100vw" />
        ))}
        <img
          src={image.src}
          srcSet={image.srcSet}
          sizes="100vw"
          width={image.width}
          height={image.height}
          alt={image.alt}
          fetchPriority="high"
          decoding="async"
        />
      </picture>
      <div className="hero__scrim" aria-hidden="true" />
      <div className="container hero__inner">
        <p className="hero__clock">
          <time dateTime={now.toISOString()}>
            {capitalize(dayFormat.format(now))} · {formatTime(now.toISOString())}
          </time>
        </p>
        <div className="hero__content">
          <p className="hero__eyebrow">
            Vivre <span aria-hidden="true">•</span> Sortir <span aria-hidden="true">•</span> Se déplacer{' '}
            <span aria-hidden="true">•</span> Aujourd’hui
          </p>
          <h1 id="hero-title" className="hero__title">
            {SITE_NAME}
          </h1>
          <p className="hero__subtitle">
            Tout ce qui se passe à Ermont, <span className="hero__nowrap">maintenant.</span>
          </p>
          <p className="hero__lead">
            Transports, météo, événements, lieux utiles… vos informations locales en un coup d’œil.
          </p>
          <div className="hero__actions">
            <Link to="/carte" className="button button--primary button--lg">
              <MapIcon size={20} aria-hidden="true" />
              Voir la carte
            </Link>
            <a href="#aujourdhui" className="button button--ghost-light button--lg hero__secondary">
              Aujourd’hui à Ermont
              <ArrowRight size={20} aria-hidden="true" />
            </a>
          </div>
        </div>
        {image.credit !== undefined && <p className="hero__credit">{image.credit}</p>}
      </div>
    </section>
  );
}
